/**
 * リクエストデータの型
 */
export interface ILaborRequest {
  attendanceType: number;
  description: string;
  absenceKind?: number;
  paidLeaveKind?: number;
  specialLeaveId?: number;
  taskId?: number;
  periodStart: string;
  periodEnd: string;
}

/**
 * 特定ユーザーの勤怠データ取得時のクエリ結果の型
 */
export interface LaborDailyReportQueryRow {
  id: number;
  attendance_type: number;
  absence_type: number | undefined;
  paid_leave_type: number | undefined;
  work_category_id: number | undefined;
  work_category_name: string | undefined;
  special_leave_id: number | undefined;
  special_leave_name: string | undefined;
  description: string | undefined;
  period_start: Date | string;
  period_end: Date | string;
}

/**
 * カレンダーイベントの種類。
 */
export const LaborCalendarEventKind = {
  WORK: 'work',
  LATE: 'late',
  EARLY: 'early',
  HOLIDAY_HALF: 'holidayHalf',
  HOLIDAY_FULL: 'holidayFull',
  ABSENCE: 'absence',
} as const;

export type LaborCalendarEventKind =
  (typeof LaborCalendarEventKind)[keyof typeof LaborCalendarEventKind];

/**
 * カレンダー用イベントのAPIレスポンス型
 */
export interface ILaborCalendarEvent {
  id: number;

  kind: LaborCalendarEventKind;

  // カレンダーの範囲判定に使う（JSTのYYYY-MM-DD）
  startYmd: string;
  endYmd?: string; // 期間なら最終日（inclusive）

  startTime?: string; // "09:00"
  endTime?: string; // "18:00"
  isAllDay: boolean;

  description: string;
  workCategoryId?: number;
  workCategoryName?: string;
  specialLeaveId?: number;
  specialLeaveName?: string;

  attendanceType: number;
  absenceType?: number;
  paidLeaveType?: number;
}
